import styled from "@mui/material/styles/styled";
import { TextField as MUITextfield } from "@mui/material";

const TextField = styled(MUITextfield)(({ theme }) => ({
  /*
  "& .MuiInputBase-root": {
    height: 30,
  },
  */
}));

TextField.defaultProps = {
  margin: "dense",
  size: "small",
  fullWidth: true,
  color: "primary",
};

export default TextField;
